// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/sentiment',
    name: 'Sentiment',
    component: layout,
    redirect: '/sentiment/index',
    meta: {
      title: '情感分析',
      icon: 'i-menu:sentiment',
      i18Key: 'router.user.sentiment.title',
      roles: [1]
    },
    sort: 52,
    children: [
      {
        path: 'index',
        name: 'SentimentIndex',
        component: () => import('@/views/Sentiment/Index.vue'),
        meta: {
          title: '推荐排名分析',
          icon: 'sentiment',
          iconIsComponent: true,
          i18Key: 'router.user.sentiment.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn'],
          isAdvanced: true
        }
      }
    ]
  }
]
export default routes
